import React, { useState, useRef, useCallback, useEffect } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Polygon,
} from "@react-google-maps/api";
import { GOOGLE_MAP_API_KEY } from "../consts";

const containerStyle = {
  width: "770px",
  height: "550px",
};
const polygonStyle = {
  fillColor: '#FF0000',
  fillOpacity: 0.3,
  strokeColor: '#FF0000',
  strokeOpacity: 1,
  strokeWeight: 2,
};
export const defaultPosition = {lat:20.5937, lng: 78.9629}
//export const defaultCenter = { lat: 20.5937, lng: 78.9629 }; // initial coordinates pointing to India
// This example presents a way to handle editing a Polygon
// The objective is to get the new path on every editing event :
// - on dragging the whole Polygon
// - on moving one of the existing points (vertex)
// - on adding a new point by dragging an edge point (midway between two vertices)

// We achieve it by defining refs for the google maps API Polygon instances and listeners with `useRef`
// Then we bind those refs to the currents instances with the help of `onLoad`
// Then we get the new path value with the `onEdit` `useCallback` and pass it to `setPath`
// Finally we clean up the refs with `onUnmount`

export default function MapComponent(props) {
  // Store Polygon path in state
  const [path, setPath] = useState();
  const [map, setMap] = useState(null);
  const polygonRef = useRef(null);
  const listenersRef = useRef([]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAP_API_KEY,
  });
  const onMapLoad = React.useCallback(function callback(map) {
    setMap(map);
  }, []);

  const onMapUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);
  // Call setPath with new edited path
  const onEdit = useCallback(() => {
    if (polygonRef.current) {
      const nextPath = polygonRef.current
        .getPath()
        .getArray()
        .map((latLng) => {
          return { lat: latLng.lat(), lng: latLng.lng() };
        });
      setPath(nextPath);
    }
  }, [setPath]);

  // Bind refs to current Polygon and listeners
  const onLoad = useCallback(
    (polygon) => {
      polygonRef.current = polygon;
      const path = polygon.getPath();
      listenersRef?.current.push(
        path?.addListener("set_at", onEdit),
        path?.addListener("insert_at", onEdit),
        path?.addListener("remove_at", onEdit)
      );
    },
    [onEdit]
  );

  // Clean up refs
  const onUnmount = useCallback(() => {
    listenersRef?.current.forEach((lis) => lis?.remove());
    polygonRef?.current?.setMap(null);
    polygonRef.current = null;
  }, []);

  useEffect(() => {
    if (map && props?.polygonData) {
      setPath(props?.polygonData);
    }
  }, [props?.polygonData, map]);

  return isLoaded ? (
    <div className="map-main">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={props?.polygonData[0] || defaultPosition}
        zoom={18}
        onLoad={onMapLoad}
        onUnmount={onMapUnmount}
         mapTypeId="satellite"
      >
        {path && (
          <Polygon
            paths={path}
            editable={false}
            draggable={false}
            onMouseUp={onEdit}
            onLoad={onLoad}
            onUnmount={onUnmount}
            options={polygonStyle}
          />
        )}
      </GoogleMap>
    </div>
  ) : (
    <></>
  );
}
